import moment from 'moment';

export const tbEventOpenForSignup = (tbEvent?: { finalSignupDate?: Date }) => {
  if (!tbEvent) return false;

  const finalMoment = tbEvent.finalSignupDate || new Date(3333,1,1);
  return moment(finalMoment).add(1, 'days') > moment();
}
